export function shouldLockSignalsWhileOcrRuns(
  ocrActive: boolean,
  canonicalSignalsReady: boolean | null,
): boolean {
  return ocrActive && canonicalSignalsReady !== true;
}

export function preferCanonicalStepStatus(
  canonicalAttemptStatus: string | null | undefined,
  legacyStepStatus: string | null | undefined,
): string | null {
  const canonical = typeof canonicalAttemptStatus === "string" && canonicalAttemptStatus.trim().length > 0
    ? canonicalAttemptStatus
    : null;
  if (canonical) return canonical;
  const legacy = typeof legacyStepStatus === "string" && legacyStepStatus.trim().length > 0
    ? legacyStepStatus
    : null;
  return legacy;
}

export function isS1ReadyForDownstream(
  canonicalSnapshotIsComplete: boolean | null | undefined,
  legacySubstepsComplete: boolean,
): boolean {
  if (typeof canonicalSnapshotIsComplete === "boolean") return canonicalSnapshotIsComplete;
  return legacySubstepsComplete;
}

export function shouldBlockS4ForSnapshotSettling(
  phase: "SETTLING" | "STABLE" | null | undefined,
  canonicalSnapshotIsComplete: boolean | null | undefined,
): boolean {
  // Snapshot settling should only block normalize when canonical S1 completion is not yet confirmed.
  // Once canonical completion is true, treat settling as advisory noise.
  if (phase !== "SETTLING") return false;
  return canonicalSnapshotIsComplete !== true;
}
